const about =
  "Welcome to UIUC U Lab! U Lab is directed by [Prof. Jiaxuan You](https://cs.stanford.edu/~jiaxuan).";

const highlights = [
  {
    title: "Accelerating Scientific Discovery",
    description:
      "**Multi-Agent Systems** like [ResearchTown](/#/publications/yu2024researchtown).",
    projects: ["ResearchTown", "GraphRouter"],
  },
];

const news = [
  {
    time: "Jan 2025",
    event:
      "🔥 DeFT is accepted at ICLR 2025. [[Paper](https://arxiv.org/abs/2404.00242)] ",
  },
  {
    time: "Jan 2025",
    event:
      "🔥 GrouphRouter is accepted at ICLR 2025. [[Paper](https://arxiv.org/abs/2410.03834)] [[Website](/publications/feng2024graphrouter)]",
  },
  {
    time: "Jan 2025",
    event: "🔥 GraphEval is accepted at ICLR 2025.",
  },
];

const impacts =
  "We actively collaborate with industry partners including Amazon and Meta.";

export { about, highlights, news, impacts };
